var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"logOutBtn",on:{"click":_vm.logOut}},[_c('i',{staticClass:"fi-power"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }